<script>
import SetCounter from '@components/counters/set-counter.vue';
import SetRow from '@components/exercise/set-row.vue';
import { circuitModelMixin } from '@mixins/models/circuit-model-mixin.js';
import { circuitMethods, circuitComputed } from '@state/helpers';

export default {
  components: {
    SetCounter,
    SetRow,
  },
  props: {
    exercise: {
      type: Object,
      required: true,
      default: () => {},
    },
    exerciseIndex: {
      type: Number,
      required: true,
      default: null,
    },
    allowEditing: {
      type: Boolean,
      required: true,
      default: false,
    }
  },
  mixins: [circuitModelMixin],
  data() {
    return {
      componentKey: 0,
    };
  },
  computed: {
    ...circuitComputed,
  },
  mounted() {},
  methods: {
    ...circuitMethods,
    onUpdateSets(type) {
      let newSet = null;
      if (
        type === 'add' &&
        this.exercise &&
        this.exercise.setDirections.length > 0
      ) {
        newSet = this.exercise.setDirections[
          this.exercise.setDirections.length - 1
        ];
      } else {
        newSet = this.getCircuitExerciseSetModel();
      }
      this.setUpdateExerciseSet({
        set: newSet,
        exerciseIndex: this.exerciseIndex,
        type,
      });
    },
    onAdjustReps(exerciseSetRep) {
      this.setUpdateExerciseSetReps({
        ...this.getCircuitExerciseSetModel(),
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetRep.index,
        count: exerciseSetRep.count,
      });
    },
    onAdjustTime(exerciseSetTime) {
      this.setUpdateExerciseSetTime({
        ...this.getCircuitExerciseSetModel(),
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetTime.index,
        count: exerciseSetTime.count,
      });
    },
    onAdjustWeight(exerciseSetWeight) {
      this.setUpdateExerciseSetWeight({
        ...this.getCircuitExerciseSetModel(),
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetWeight.index,
        count: exerciseSetWeight.count,
      });
    },
    onAdjustRest(exerciseSetRest) {
      this.setUpdateExerciseSetRest({
        ...this.getCircuitExerciseSetModel(),
        exerciseIndex: this.exerciseIndex,
        exerciseSetIndex: exerciseSetRest.index,
        count: exerciseSetRest.count,
      });
    },
  },
  watch: {
    selectedCircuit(newVal, oldVal) {
      this.componentKey += 1;
    },
  },
};
</script>

<template>
  <div class="exercise-set-details" :key="componentKey">
    <div class="row">
      <div class="col-2">
        <div class="exercise-set-details-header">
          <div class="row">
            <div class="col">
              <span class="set-details-title">Sets</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <SetCounter
              :key="exercise.setDirections.length"
              :count="exercise.setDirections.length"
              @update-sets="onUpdateSets"
              :allowEditing="allowEditing"
            />
          </div>
        </div>
      </div>

      <div class="col">
        <div class="exercise-set-details-header">
          <div class="row">
            <div class="col">
              <span class="set-details-title">Reps</span>
            </div>
            <div class="col">
              <span class="set-details-title">Time</span>
            </div>
            <div class="col">
              <span class="set-details-title">Weight</span>
            </div>
            <div class="col">
              <span class="set-details-title">Rest After</span>
            </div>
          </div>
        </div>

        <SetRow
          v-for="(setDirections, i) in exercise.setDirections"
          :key="i"
          :setDirections="setDirections"
          :exerciseSetIndex="i"
          @adjust-reps="onAdjustReps"
          @adjust-time="onAdjustTime"
          @adjust-weight="onAdjustWeight"
          @adjust-rest="onAdjustRest"
          :allowEditing="allowEditing"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.exercise-set-details {
  .exercise-set-details-header {
    border-bottom: 1px solid $color-light-gray;
    padding: 0 0 2.15rem;

    .col {
      text-align: center;
    }
  }

  .set-details-title {
    color: $color-text;
    font-size: 1.2rem;
    font-weight: bold;
    letter-spacing: 1.34675px;
    line-height: 1.6rem;
    text-transform: uppercase;
  }
}
</style>
